import { render, staticRenderFns } from "./ProposalTerm.vue?vue&type=template&id=670590e1&"
import script from "./ProposalTerm.vue?vue&type=script&lang=js&"
export * from "./ProposalTerm.vue?vue&type=script&lang=js&"
import style0 from "./ProposalTerm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports